import { render, staticRenderFns } from "./testMethod.vue?vue&type=template&id=642dc430&scoped=true&"
import script from "./testMethod.vue?vue&type=script&lang=js&"
export * from "./testMethod.vue?vue&type=script&lang=js&"
import style0 from "./testMethod.vue?vue&type=style&index=0&id=642dc430&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642dc430",
  null
  
)

export default component.exports